import React from "react";

import { Box } from "../Box/Box";

type BoxProps = React.ComponentPropsWithoutRef<typeof Box>;

export type StackProps = BoxProps & {
  children?:
    | React.JSX.Element
    | (React.JSX.Element[] | React.JSX.Element | null)[]
    | null
    | React.ReactNode;
  testID?: string;
};

export const Stack = React.forwardRef<React.ElementRef<typeof Box>, StackProps>(
  function Stack({ children, ...restyleProps }, ref) {
    return (
      <Box ref={ref} flexDirection={"column"} {...restyleProps}>
        {children}
      </Box>
    );
  }
);
